"use strict";

/* eslint-disable react/jsx-filename-extension */
var React = require('react');
var _require = require('./queries/constants'),
  BLOG_DESTINATION_TYPE = _require.BLOG_DESTINATION_TYPE;
var _require2 = require('./queries/utils'),
  getDestinationParentSlug = _require2.getDestinationParentSlug;
var _require3 = require('./utils'),
  cleanSlug = _require3.cleanSlug;
function preferDefault(module) {
  return module && module["default"] || module;
}
function isCannotFindModuleError(error) {
  return error.toString().indexOf('Error: Cannot find module') !== -1;
}
function isBlogPostPath(path, blogRootSlug) {
  var cleanedSlug = cleanSlug(blogRootSlug);
  return path.includes(cleanedSlug) && !path.endsWith("/".concat(cleanedSlug, "/"));
}
var Layout;
try {
  // eslint-disable-next-line global-require, no-undef, import/no-dynamic-require
  Layout = preferDefault(require(BLOG_LAYOUT_COMPONENT_PATH));
} catch (e) {
  if (isCannotFindModuleError(e)) {
    // eslint-disable-next-line no-undef
    throw new Error("Couldn't find layout component at \"".concat(BLOG_LAYOUT_COMPONENT_PATH, "\"."));
  }
}

// eslint-disable-next-line consistent-return
module.exports = function wrapPage(_ref, _ref2) {
  var element = _ref.element,
    props = _ref.props;
  var layoutComponent = _ref2.layoutComponent,
    blogRootSlug = _ref2.blogRootSlug,
    _ref2$postDestination = _ref2.postDestination,
    postDestination = _ref2$postDestination === void 0 ? BLOG_DESTINATION_TYPE : _ref2$postDestination;
  var _props$location = props.location,
    location = _props$location === void 0 ? {} : _props$location;
  var _location$pathname = location.pathname,
    pathname = _location$pathname === void 0 ? '' : _location$pathname;
  var rootSlug = blogRootSlug || getDestinationParentSlug(postDestination);
  if (isBlogPostPath(pathname, rootSlug) && layoutComponent) {
    return /*#__PURE__*/React.createElement(Layout, props, element);
  }
};